<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../../public/images/liaoning/darkheader.png")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入辽宁移动手机号")
        el-form-item
          .verifycode
            .txt-verfiycode
              input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
            .btn-verifycode
              button(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          el-button(type="warning", @click="handleSubmit") 立即办理
    .notice
      .title - 活动规则 -
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index", v-if="index <= 1 || showMoreNotice")
            .num {{index + 1}}.
            p.content {{notice}}
        .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多活动规则
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '流量包内的10GB流量为国内（不含港澳台）套外通用流量，需在套餐内包含的流量用完后使用，流量不支持结转及多终端共享。',
        '活动办理立即生效，功能费一次性收取，不区分上下半月。',
        '活动限入网6个月及以上（含），且近6个月套餐、基础流量包、任我用流量包未降档的4G实名制客户办理。',
        '成长包PLUS版标准价30元/月含10GB国内套外通用流量。首年优惠10元/月，享12个月优+会员轻享版和100枚金币权益，权益到期自动失效。次年起，恢复至标准价30元/月，流量每年涨2GB/月，连涨3年。第三年30元14GB/月国内套外通用流量。第四年起客户无活动终止意向，保持30元16GB/月国内套外通用流量。',
        '1年优+会员轻享版权益：办理成长包Plus版自动生效，到期自动取消。关注辽宁移动微信公众号，回复关键字“优+”，点击辽宁移动权益中心，每月可享2次10G日流量及青桔单车、滴滴快车、饿了么、球迷福利报等免费大礼包，更有爱奇艺、腾讯视频、优酷、芒果、美团、QQ音乐会员和流量折扣券。',
        '活动期内，客户套餐不可降档，基础流量包、任我用流量包不可降档或取消；办理活动客户支持申请预销号、销户、停机保号等，如需办理以上业务，需先到辽宁移动营业厅进行活动终止。',
        '活动有效期内不可重复办理，不同档位可叠加办理，已办理老版成长包系列活动客户，可以办理新版成长包系列活动。',
        '活动连带流量产品费用不计入翻倍送承诺低消范围内。',
        '办理成功后的用户，可关注冰蓝流量，回复“辽宁移动”抽取12张5元话费券，具体抽取规则。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 10,
        userId: '',
        goodsCode: 'WXMP01600004'
      },
      channel: 'TUIA',
      showMoreNotice: false
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            this.syncOrderStatus(res.data.sub_data.orderId)
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    syncOrderStatus(orderId) {
      try{
        let _loading = this.$loading({
          lock: true,
          text: '请稍后，正在查询办理结果',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$service.CarrierService
          .queryOrder(orderId)
          .then(res => {
            // W-等待运营商返回处理结果；0-办理成功；1-办理失败，
            if (res.data.success) {
              if (res.data.sub_data.execStatus == '0') {
                _loading.close()
                if (window.countLog) {
                  window.countLog.ready(function() {
                    window.countLog.init(function() { 
                    }, {
                      isCopy: 0, 
                      pageType: 0 
                    })
                  })
                }
                this.$message({
                  type: 'success',
                  message: '办理成功'
                })
                this.$router.push({
                  name: 'liaoningFlowCommonSuccess'
                })
              } else if (res.data.sub_data.execStatus == 'W') {
                setTimeout(() => {
                  _loading.close()
                  this.syncOrderStatus(orderId)
                }, 1000)
              } else {
                _loading.close()
                this.$message({
                  type: 'warning',
                  message: `订单查询：办理失败`
                })
              }
            } else {
              _loading.close()
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
          .catch(() => {
            _loading.close()
            this.$message({
              type: 'error',
              message: '办理失败，请稍后再再试'
            })
          })
      } catch (err) {
        console.log(err)
        this.errlog = err.message;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #061649;
  padding-bottom: 3.5rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  margin-top: 4rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    padding: 1rem 2rem 1.2rem;
    border-radius: .4rem;
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #fff;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #c3c3c3;
    }
  }
}
.form{
  width: 80%;
  margin: 0 auto;
  margin-top: -200px;
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
    }
  }
  .verifycode{
    display: flex;
    height: 40px;
    line-height: 40px;
  }
  .btn-verifycode{
    flex: .7;
    button{
      background-color: #fff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 100%;
      border: 0;
      outline: 0;
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .txt-verfiycode{
    width: 100%;
    flex: 1.3;
    input{
      background-color: #fff;
      // border: 1px solid #DCDFE6;
      border: 0;
      border-right: 0;
      padding: 0 15px;
      outline: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #606266;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-color: #fff;
      box-sizing: border-box;
      &::-webkit-input-placeholder{
        color: #b9b9b9;
        font-size: 14px;
      }
    }
  }
}
</style>
